/** Conversion goals selected for a single onboarding brief; pageviews/revenue are separate. */
export const MAX_ONBOARDING_GOALS = 5;

export const BUSINESS_OUTCOMES = {
  activation: {
    name: 'Activation',
    eventName: 'activation_completed',
    trigger:
      'The account completes its first core workflow and reaches meaningful value.',
  },
  lead: {
    name: 'Leads',
    eventName: 'lead_submitted',
    trigger: 'A visitor successfully submits a sales or contact inquiry.',
  },
  trial: {
    name: 'Trial starts',
    eventName: 'trial_started',
    trigger: 'A user successfully starts a distinct product trial.',
  },
} as const;

export type TrackingGoal = { name: string; eventName: string; trigger: string };

export const customTrackingGoals = (plan?: {
  customGoals?: TrackingGoal[];
  customGoal?: TrackingGoal | null;
}): TrackingGoal[] =>
  plan?.customGoals ?? (plan?.customGoal ? [plan.customGoal] : []);

export const selectedTrackingGoals = (plan?: {
  signups: boolean;
  customGoals?: TrackingGoal[];
  customGoal?: TrackingGoal | null;
}): TrackingGoal[] => [
  ...(plan?.signups
    ? [
        {
          name: 'Signups',
          eventName: 'signup_completed',
          trigger:
            'A new account is successfully created, including social signups.',
        },
      ]
    : []),
  ...customTrackingGoals(plan),
];
